import React from 'react';
import { Form, Field } from 'react-final-form';
import Button, {
  buttonTypes,
  buttonSizes,
  buttonTextSizes,
  buttonFunctions,
} from '../../../shared/Button';
import { submitText } from '../../../shared/SharedInternationalizations';
import { HelpWithIcon } from '../../../shared/HelpIcon';
import { searchCatalog } from './query-utils';
import QueryContext from './query-context';

const InputField = ({param, curValue=null}) => {
  const helpInfo = {
    helpId: `InputField.${param.name}.HelpText`,
    text: param.desc,
  };
  const effectiveValue = curValue ?? param.default;
  console.log('InputField: effectiveValue: ', effectiveValue)
 // const validate = param.required ? required : undefined;
  return (
    <div className="form__item-container">
      <div className="align-center">
        <label
          className={`text-medium text-bold form-item__field-message${param.required ? '--required' : ''}`}
          htmlFor={param.name}>
          {param.label}:
        </label>
        <HelpWithIcon {...helpInfo} />
      </div>
      <Field
        className="form-item__field"
        name={param.name}
        component="input"
        defaultValue={effectiveValue}
        value={effectiveValue}
      />
    </div>
  );
};

export default function QueryForm ({id}) {
  console.log('QueryForm: item id: ', id)
  //console.log('QueryForm: formData: ', formData)
  const { catalog, onSubmit } = React.useContext(QueryContext)
  //console.log('Inside QueryFormWrap: id', id);
  const item = searchCatalog(id, catalog)
  console.log('Inside QueryFormWrap: item', item);

  const onSubmitItem = (formData) => {
    //console.log('QueryForm: onSubmitItem: formData: ', formData);
    onSubmit(item, formData);
  }
  
  return (
    <>
      <Form
        data-test="query-form"
        onSubmit={onSubmitItem}
        render={({
          handleSubmit,
          pristine,
          invalid,
          reset,
          submitting,
          values,
        }) => (
          <form onSubmit={handleSubmit} className="width-100">

            {/* -- Fields */}
            <div className="form__section-container form__section-container--grid margin-bottom-25">
              {
                item && item.params.map((param, index) =>{
                  const val = item.formData?.[param.name] ?? param.default
                  console.log('QueryForm: val: ', val)
                  return (
                    <InputField param={param} key={index} curValue={val} />
                  )
                })
              }
            </div>

            {/* -- Submit Button */}
            <div className="form__section-container form__section-container--spread">
              <div className="form__items-group-container" />
              <div className="form__items-group-container">
                <Button
                  buttonFunction={buttonFunctions.submit}
                  text={submitText}
                  buttonType={buttonTypes.success}
                  buttonSize={buttonSizes.small}
                  buttonTextSize={buttonTextSizes.mediumSmall}
                  additionalStyles="no-margin margin-left-15"
                  disabled={pristine || invalid}
                />
              </div>
            </div>
          </form>
        )}
      />
    </>
  );
};

